import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  className: string
}

export const Divider: React.FC<Props> = ({ className }) => {
  return <hr className={clsJoin(css.divider, className)} />
}
